module.exports = __webpack_public_path__ + "mobile/img/img_checkin_banner.3fe2c612.png";